import { BaseService } from './base.service';
import { IUserLogin } from '../models/user';
import { Uris } from '../common/constants';
import Axios from 'axios';
export interface IAuthorizationService {
  handleAuthorize: (userInfo: IUserLogin) => Promise<any>;
  handleGetFunctionalities: (moduleName: string) => Promise<any>;
  verifyEmail: (token: string) => Promise<any>;
  sendForgotPassword: (payload: {
    value: {
      email: string
    },
    action: "sendResetPwd"
  }) => Promise<any>;
  submitChangePassword: (payload: {
    value: {
      password: string
      token: string
      confirmedPassword: string
    },
    action: "resetPwdLong"
  }) => Promise<any>;
  handleCheckSession: (accessToken: string) => Promise<boolean>
  handleLogout: () => Promise<boolean>
}
export class AuthorizationService extends BaseService implements IAuthorizationService {
  submitChangePassword(payload: { value: { password: string; token: string; confirmedPassword: string; }; action: "resetPwdLong"; }): Promise<any> {
    return super.post(Uris.AuthorizationForgot, payload)
      .then(res => {
        return Promise.resolve(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  sendForgotPassword(payload: { value: { email: string; }; action: "sendResetPwd"; }): Promise<any> {
    return super.post(Uris.AuthorizationForgot, payload)
      .then(res => {
        return Promise.resolve(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  constructor() {
    super();
  }

  /**
   * Authorize user info
   * @param userInfo email: string | passsword: string | expires: boolen | strategy: "local"
   */
  async handleAuthorize(userInfo: IUserLogin): Promise<any> {
    return await super.post(Uris.Authorization, userInfo)
      .then(auth => {

        const { accessToken } = auth;
        Axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        localStorage.setItem('token', accessToken)
        return Promise.resolve(auth);
      })
      .catch((error) => Promise.reject(error))
  }

  async handleLogout(): Promise<any> {
    return await super.delete(Uris.Authorization)
      .then(result => {
        localStorage.clear();
        return result;
      })
      .catch((error) => Promise.reject(error))
  }

  async handleGetFunctionalities(moduleName: string) {
    return super.get(Uris.UserFunctionality, { module: moduleName })
      .then((response: any) => {
        const result: { [key: string]: boolean } = {};
        response.data.forEach(key => result[key] = true);
        return result;
      })
      .catch(error => error)
  }


  async handleCheckSession(accessToken: string) {
    if (accessToken !== null) {
      Axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      return true;
    }
    else return false;
  }
  async verifyEmail(token: string) {
    return await super.post(Uris.AuthorizationForgot, {
      action: "verifySignupLong",
      value: token
    })
  }
}


// WEBPACK FOOTER //
// ./src/services/authorization.service.ts